import { HttpService } from '@/common/services/http.service';

const ResourceService = {
  ADMIN_API_HOST: process.env.VUE_APP_ADMIN_HOST,

  getResourcePage() {
    return HttpService.httpGet(`${this.ADMIN_API_HOST}/api/resources`);
  }
};

export default ResourceService;
